var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#03A9F3",
        height: "23",
        viewBox: "0 0 27 23",
        width: "27",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "fill-rule": "nonzero" } }, [
        _c("path", {
          attrs: {
            d: "M25.002 0H6.498C5.388 0 4.5.998 4.5 2.186V14.76c0 1.215.913 2.186 1.998 2.186h12.755l2.887 3.184a.595.595 0 0 0 .444.216c.345 0 .641-.297.641-.701v-2.699h1.777c1.11 0 1.998-.998 1.998-2.186V2.186C27 .97 26.087 0 25.002 0zM9.336 10.82c-1.012 0-1.85-.917-1.85-2.023s.838-2.024 1.85-2.024c1.011 0 1.85.918 1.85 2.024 0 1.106-.814 2.024-1.85 2.024zm6.488 0c-1.011 0-1.85-.917-1.85-2.023s.838-2.024 1.85-2.024 1.85.918 1.85 2.024c0 1.106-.838 2.024-1.85 2.024zm6.464 0c-1.012 0-1.85-.917-1.85-2.023s.838-2.024 1.85-2.024c1.011 0 1.85.918 1.85 2.024 0 1.106-.839 2.024-1.85 2.024z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M3.246 14.577v-3.962H1.275c-.697 0-1.274.598-1.274 1.321v7.625c-.024.773.553 1.37 1.274 1.37h1.13v1.645c0 .225.192.424.408.424.12 0 .217-.05.289-.125l1.85-1.918h8.174c.697 0 1.274-.598 1.274-1.321v-1.894H6.299c-1.683 0-3.053-1.42-3.053-3.165z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }